import Icon from './Icon.jsx';

/**
 * ErrorState — render when a fetch rejects. The retry handler is optional;
 * if provided the call site is expected to be idempotent.
 */
export default function ErrorState({ title = 'Something went wrong', message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-f1-red/10 text-f1-red ring-1 ring-f1-red/30">
        <Icon name="alert" size={26} />
      </div>
      <h3 className="text-lg font-semibold text-ink-primary">{title}</h3>
      {message ? (
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-ink-secondary">{message}</p>
      ) : null}
      {onRetry ? (
        <button
          onClick={onRetry}
          className="pressable mt-6 inline-flex items-center gap-2 rounded-full bg-f1-red px-5 py-2.5 text-sm font-semibold text-white shadow-glow-red-soft transition-colors hover:bg-f1-redBright"
        >
          <Icon name="refresh" size={16} />
          Retry
        </button>
      ) : null}
    </div>
  );
}
